import React, { useEffect, useState, useRef } from 'react'
import './SignatureByteArray.scss'

const SignatureByteArray = ({ bytes = '', updateBytes }) => {
  const fieldId = 'SignatureImage'
  const [droppable, setDroppable] = useState(false)
  const inputRef = useRef()

  const preventDrop = (e) => {
    e.preventDefault()
  }
  const hideDroppableIndicator = (e) => {
    preventDrop(e)
    setDroppable({ droppable: false })
  }
  const showDroppableIndicator = (e) => {
    preventDrop(e)
    setDroppable({ droppable: true })
  }

  useEffect(() => {
    window.addEventListener('dragover', showDroppableIndicator, false)
    window.addEventListener('drop', hideDroppableIndicator, false)
    return () => {
      window.removeEventListener('dragover', showDroppableIndicator, false)
      window.removeEventListener('drop', hideDroppableIndicator, false)
    }
  }, [])

  const handleChange = (e) => {
    const file = e.target.files[0]

    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = (event) => {
        resolve(event.target.result)
      }
      reader.onerror = (err) => {
        reject(err)
      }
      reader.readAsDataURL(file)
    })
      .then((newBytes) => {
        updateBytes(newBytes, file)
      })
      .catch((err) => {
        console.error(err)
      })
  }

  const handleFileDrop = (e) => {
    e.preventDefault()
    let files = []
    for (let i = 0; i < e.dataTransfer.items.length; i++) {
      if (e.dataTransfer.items[i].kind === 'file') {
        const file = e.dataTransfer.items[i].getAsFile()
        if (file) files.push(file)
      }
    }
    if (files.length) handleChange({ target: { files } })
  }

  return (
    <div>
      <div className="property-label">{`Signature Image`}</div>
      <div className="display-image">
        {bytes.length > 0 ? (
          <img
            src={
              bytes.includes('data:image/png;base64,') ? bytes : 'data:image/png;base64,' + bytes
            }
            style={{ maxHeight: 200 }}
            alt="Signature"
          />
        ) : (
          'No Image Selected'
        )}
      </div>
      <div className="file-wrapper">
        <div className="row">
          <div className="col-xl-7 col-lg-8 col-md-9">
            <input
              className="hidden-upload"
              type="file"
              id={fieldId}
              name={fieldId}
              onChange={(e) => handleChange(e)}
              accept={'.png'}
              ref={inputRef}
            />
            <label className={`styled-file-upload `} htmlFor={fieldId} onDrop={handleFileDrop}>
              <span className={`icon icon-upload ${droppable ? 'droppable-animation' : ''}`} />
              {droppable ? 'Drop file here to upload' : `Select a file to upload (.png)`}
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignatureByteArray
